import React, { useState } from 'react';
import { Smartphone, Tv, Wifi, Zap, Receipt } from 'lucide-react';
const BillPayments = () => {
  const [selectedCategory, setSelectedCategory] = useState('airtime');
  const categories = [{
    id: 'airtime',
    name: 'Airtime',
    icon: <Smartphone className="h-6 w-6" data-id="element-267" />
  }, {
    id: 'data',
    name: 'Data',
    icon: <Wifi className="h-6 w-6" data-id="element-268" />
  }, {
    id: 'tv',
    name: 'TV',
    icon: <Tv className="h-6 w-6" data-id="element-269" />
  }, {
    id: 'electricity',
    name: 'Electricity',
    icon: <Zap className="h-6 w-6" data-id="element-270" />
  }];
  const recentPayments = [{
    id: 1,
    category: 'Airtime',
    recipient: '+234 812 345 6789',
    amount: 10,
    date: '2023-06-15',
    status: 'completed'
  }, {
    id: 2,
    category: 'TV',
    recipient: 'DSTV Premium',
    amount: 45,
    date: '2023-06-10',
    status: 'completed'
  }, {
    id: 3,
    category: 'Data',
    recipient: '+234 812 345 6789',
    amount: 20,
    date: '2023-06-05',
    status: 'completed'
  }, {
    id: 4,
    category: 'Electricity',
    recipient: 'Ikeja Electric',
    amount: 50,
    date: '2023-06-01',
    status: 'completed'
  }];
  return <div className="py-6" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-272">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-273">Bill Payments</h1>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-274">
        <div className="mt-6" data-id="element-275">
          {/* Categories */}
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4" data-id="element-276">
            {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`${selectedCategory === category.id ? 'bg-blue-50 border-blue-500 text-blue-700' : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'} flex flex-col items-center p-6 border-2 rounded-lg transition-colors`} data-id="element-277">
                <div className={`${selectedCategory === category.id ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-278">
                  {category.icon}
                </div>
                <span className="mt-2 text-sm font-medium" data-id="element-279">
                  {category.name}
                </span>
              </button>)}
          </div>
          {/* Payment Form */}
          <div className="mt-8" data-id="element-280">
            <div className="bg-white shadow sm:rounded-lg" data-id="element-281">
              <div className="px-4 py-5 sm:p-6" data-id="element-282">
                <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-283">
                  {selectedCategory === 'airtime' && 'Airtime Recharge'}
                  {selectedCategory === 'data' && 'Data Bundle Purchase'}
                  {selectedCategory === 'tv' && 'TV Subscription'}
                  {selectedCategory === 'electricity' && 'Electricity Bill Payment'}
                </h3>
                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2" data-id="element-284">
                  {/* Provider selection for TV and Electricity */}
                  {(selectedCategory === 'tv' || selectedCategory === 'electricity') && <div className="sm:col-span-2" data-id="element-285">
                      <label htmlFor="provider" className="block text-sm font-medium text-gray-700" data-id="element-286">
                        {selectedCategory === 'tv' ? 'TV Provider' : 'Electricity Provider'}
                      </label>
                      <select id="provider" name="provider" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-287">
                        {selectedCategory === 'tv' ? <>
                            <option data-id="element-288">DSTV</option>
                            <option data-id="element-289">GOTV</option>
                            <option data-id="element-290">StarTimes</option>
                            <option data-id="element-291">Showmax</option>
                          </> : <>
                            <option data-id="element-292">Ikeja Electric</option>
                            <option data-id="element-293">Eko Electric</option>
                            <option data-id="element-294">Abuja Electric</option>
                            <option data-id="element-295">Ibadan Electric</option>
                          </>}
                      </select>
                    </div>}
                  {/* Network selection for Airtime and Data */}
                  {(selectedCategory === 'airtime' || selectedCategory === 'data') && <div className="sm:col-span-2" data-id="element-296">
                      <label htmlFor="network" className="block text-sm font-medium text-gray-700" data-id="element-297">
                        Network Provider
                      </label>
                      <select id="network" name="network" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-298">
                        <option data-id="element-299">MTN</option>
                        <option data-id="element-300">Airtel</option>
                        <option data-id="element-301">Glo</option>
                        <option data-id="element-302">9mobile</option>
                      </select>
                    </div>}
                  {/* Phone Number for Airtime and Data */}
                  {(selectedCategory === 'airtime' || selectedCategory === 'data') && <div className="sm:col-span-2" data-id="element-303">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-304">
                        Phone Number
                      </label>
                      <div className="mt-1" data-id="element-305">
                        <input type="tel" name="phone" id="phone" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="+234 800 000 0000" data-id="element-306" />
                      </div>
                    </div>}
                  {/* Smart Card / Meter Number for TV and Electricity */}
                  {(selectedCategory === 'tv' || selectedCategory === 'electricity') && <div className="sm:col-span-2" data-id="element-307">
                      <label htmlFor="account-number" className="block text-sm font-medium text-gray-700" data-id="element-308">
                        {selectedCategory === 'tv' ? 'Smart Card Number' : 'Meter Number'}
                      </label>
                      <div className="mt-1" data-id="element-309">
                        <input type="text" name="account-number" id="account-number" className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder={selectedCategory === 'tv' ? '0123456789' : '01234567890'} data-id="element-310" />
                      </div>
                    </div>}
                  {/* Package selection for Data and TV */}
                  {(selectedCategory === 'data' || selectedCategory === 'tv') && <div className="sm:col-span-2" data-id="element-311">
                      <label htmlFor="package" className="block text-sm font-medium text-gray-700" data-id="element-312">
                        {selectedCategory === 'data' ? 'Data Bundle' : 'Subscription Package'}
                      </label>
                      <select id="package" name="package" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-313">
                        {selectedCategory === 'data' ? <>
                            <option data-id="element-314">1GB - 1 Day ($2)</option>
                            <option data-id="element-315">2GB - 7 Days ($5)</option>
                            <option data-id="element-316">5GB - 30 Days ($10)</option>
                            <option data-id="element-317">10GB - 30 Days ($20)</option>
                          </> : <>
                            <option data-id="element-318">Basic - 1 Month ($15)</option>
                            <option data-id="element-319">Standard - 1 Month ($25)</option>
                            <option data-id="element-320">Premium - 1 Month ($45)</option>
                            <option data-id="element-321">Compact - 1 Month ($35)</option>
                          </>}
                      </select>
                    </div>}
                  {/* Amount for Airtime and Electricity */}
                  {(selectedCategory === 'airtime' || selectedCategory === 'electricity') && <div className="sm:col-span-2" data-id="element-322">
                      <label htmlFor="amount" className="block text-sm font-medium text-gray-700" data-id="element-323">
                        Amount
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-324">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-325">
                          <span className="text-gray-500 sm:text-sm" data-id="element-326">$</span>
                        </div>
                        <input type="text" name="amount" id="amount" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" aria-describedby="price-currency" data-id="element-327" />
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-328">
                          <span className="text-gray-500 sm:text-sm" id="price-currency" data-id="element-329">
                            USD
                          </span>
                        </div>
                      </div>
                    </div>}
                  {/* Payment Source */}
                  <div className="sm:col-span-2" data-id="element-330">
                    <label htmlFor="payment-source" className="block text-sm font-medium text-gray-700" data-id="element-331">
                      Pay From
                    </label>
                    <select id="payment-source" name="payment-source" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-332">
                      <option data-id="element-333">USD Wallet ($2,540.50)</option>
                      <option data-id="element-334">GBP Wallet (£1,250.75)</option>
                      <option data-id="element-335">NGN Wallet (₦450,000.00)</option>
                    </select>
                  </div>
                </div>
                <div className="mt-6" data-id="element-336">
                  <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-337">
                    Make Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Recent Payments */}
          <div className="mt-10" data-id="element-338">
            <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-339">
              Recent Bill Payments
            </h2>
            <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-340">
              <ul role="list" className="divide-y divide-gray-200" data-id="element-341">
                {recentPayments.map(payment => <li key={payment.id} data-id="element-342">
                    <div className="px-4 py-4 sm:px-6" data-id="element-343">
                      <div className="flex items-center justify-between" data-id="element-344">
                        <div className="flex items-center" data-id="element-345">
                          <div className="flex-shrink-0" data-id="element-346">
                            <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-347">
                              <Receipt className="h-5 w-5 text-gray-600" data-id="element-348" />
                            </div>
                          </div>
                          <div className="ml-4" data-id="element-349">
                            <p className="text-sm font-medium text-gray-900" data-id="element-350">
                              {payment.category}
                            </p>
                            <p className="text-sm text-gray-500" data-id="element-351">
                              {payment.recipient}
                            </p>
                          </div>
                        </div>
                        <div className="ml-6 flex items-center" data-id="element-352">
                          <p className="text-sm font-medium text-gray-900" data-id="element-353">
                            ${payment.amount.toFixed(2)}
                          </p>
                          <div className="ml-2 flex-shrink-0" data-id="element-354">
                            <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-355">
                              {payment.status}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 sm:flex sm:justify-between" data-id="element-356">
                        <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-357">
                          <svg className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-358">
                            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" data-id="element-359" />
                          </svg>
                          <span data-id="element-360">{payment.date}</span>
                        </div>
                      </div>
                    </div>
                  </li>)}
              </ul>
              <div className="bg-white px-4 py-3 border-t border-gray-200 text-center" data-id="element-361">
                <button className="text-sm font-medium text-blue-600 hover:text-blue-500" data-id="element-362">
                  View all transactions
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default BillPayments;